import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationCreateVisualLanguageArgs,
  BackendVisualLanguage,
} from 'src/types/backend';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const MUTATION = gql`
  mutation CreateVisualLanguage($customerId: ID!, $workspaceId: ID, $name: String!) {
    createVisualLanguage(name: $name, customerId: $customerId, workspaceId: $workspaceId) {
      ...VisualLanguage
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
`;

type Variables = BackendMutationCreateVisualLanguageArgs;
type Result = BackendVisualLanguage;

export const createVisualLanguage = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
